import React from 'react';
import {
    Heading,
   
    Text,
   
    Flex,

    useColorModeValue,
    SimpleGrid,
    Link,
    IconButton,
    Grid,
    GridItem,
    useMediaQuery
} from "@chakra-ui/react";
// import {  SiFirebase, SiGmail, SiCss3 ,SiHtml5,SiTypescript, SiExpressvpn,SiMongodb,SiRedux, SiGnubash} from 'react-icons/si';
import {  FaLinkedin,  FaGithub ,  FaPhoneAlt, FaTwitter} from "react-icons/fa";

import { FiMail } from "react-icons/fi";
// import { liveProjects } from '../constant/inde';
// import { LiveProjectCard } from '../components/LiveProjectCard';

const Contact = () => {
  const [isLarge] = useMediaQuery('(min-width:  992px)')
    return (
        
<>
            <Heading
                as="h1"
                fontSize={{ base: "24px", md: "30px", lg: "36px" }}
                mb={3}
            >
            Contact me
            </Heading>
            <Grid
                 p='4'
                  w = '92%'
                  m = 'auto'
                mt={5}
                templateColumns={["1fr", "repeat(2,1fr)", "repeat(3, 1fr)", "repeat(3, 1fr)"]}
                gap={[2, 6, 6, 6]}
            >
              <GridItem justifySelf={isLarge ? 'flex-start' : 'center'}><Text textColor={useColorModeValue("gray.600", "gray.400")} fontSize={'md'}>
            <FiMail/> Please drop a mail at <Text textColor='blue.500' fontSize={'md'}>harshu864@gmail.com</Text>
            </Text>
           </GridItem> 
            <GridItem  justifySelf='center'><Text textColor={useColorModeValue("gray.600", "gray.400")} fontSize={'md'}>
            <FaPhoneAlt/>or you can reach me at  <Text textColor='blue.500'   fontSize={'md'}>+91 7017557912</Text>
            </Text></GridItem> 
            <GridItem  justifySelf={isLarge ? 'flex-end' : 'center'}>  <Text textColor={useColorModeValue("gray.600", "gray.400")} fontSize={'md'}>
                also please connect with me on.
            </Text>
            <Flex gap='9'>
            <Link href='https://www.linkedin.com/in/harsh-upadhayay-b27aa9202' isExternal style={{ textDecoration: 'none' }}>
            <IconButton
  colorScheme='linkedin'
  aria-label='Search database'
  icon={<FaLinkedin />}
  size='lg'
/>
        </Link>
        <Link href='https://github.com/harshu878' isExternal style={{ textDecoration: 'none' }}>
        <IconButton
color={'black'}
backgroundColor='darkgray'
  aria-label='Github'
  icon={<FaGithub />}
  size='lg'
/>
        </Link>
        <Link href='https://twitter.com/harshup06803036' isExternal style={{ textDecoration: 'none' }}>
        <IconButton
  colorScheme='twitter'
  aria-label='twitter'
  icon={<FaTwitter />}
  size='lg'
/>
        </Link>
            </Flex></GridItem> 
            </Grid>
            {/* <Text textColor={useColorModeValue("gray.600", "gray.400")} fontSize={'md'}>
            <FiMail/> Please drop a mail at <Text textColor='blue.500' fontSize={'md'}>harshu864@gmail.com</Text>
            </Text>
            or 
            <Text textColor={useColorModeValue("gray.600", "gray.400")} fontSize={'md'}>
            <FaPhoneAlt/> You can reach me at  <Text textColor='blue.500'   fontSize={'md'}>+91 7017557912</Text>
            </Text>
            <Text textColor={useColorModeValue("gray.600", "gray.400")} fontSize={'md'}>
                also please connect with me on.
            </Text>
            <Flex  alignItems='center' gap='9'>
            <Link href='https://github.com/harshu878' isExternal style={{ textDecoration: 'none' }}>
            <IconButton
  colorScheme='linkedin'
  aria-label='Search database'
  icon={<FaLinkedin />}
  size='lg'
/>
        </Link>
        <Link href='https://www.linkedin.com/in/harsh-upadhyay-b27aa9202/' isExternal style={{ textDecoration: 'none' }}>
        <IconButton
color={'black'}
backgroundColor='darkgray'
  aria-label='Github'
  icon={<FaGithub />}
  size='lg'
/>
        </Link>
        <Link href='https://twitter.com/harshup06803036' isExternal style={{ textDecoration: 'none' }}>
        <IconButton
  colorScheme='twitter'
  aria-label='twitter'
  icon={<FaTwitter />}
  size='lg'
/>
        </Link>
            </Flex> */}
    </> 
    )
}
export default Contact